export default {
	CONFIG: {
	},
	FEATURE: {
	}
}